import DefaultImg from "assets/images/main-classes-img1.svg";

export const getImageUrl = (prefix: any, file: any) => {
	if (!prefix || !file) return DefaultImg;
	return prefix + file?.filePath + "/" + file?.name;
};
